import React from 'react';
import {View, ViewStyle} from 'react-native';
import {Button} from '../../../shared/components/button';
import {Markdown} from '../../../shared/components/markdown';
import {Modal} from '../../../shared/components/modal/modal';
import {Text} from '../../../shared/components/text';
import {dateFormats} from '../../../shared/constants/date';
import {datePipe} from '../../../shared/pipes/date';
import {useTheme} from '../../../shared/theme';
import {IStateProps} from './model';
import useStyles from './style';

export default ({onModalClose, onNotificationPress, notification}: IStateProps) => {
  const theme = useTheme();
  const styles = useStyles();

  if (!notification) return null;

  return (
    <Modal
      onClose={onModalClose}
      title={notification.topic}
      titleStyle={styles.title as ViewStyle}
      wrapStyle={styles.container}>
      <View testID='notification--body'>
        <Markdown textStyle={theme.fonts.h6Light}>{notification.text}</Markdown>
      </View>
      {onNotificationPress && (
        <View style={styles.buttonWrap}>
          <Button
            id='notifications-description'
            style={styles.button}
            type='secondary'
            text='Подробнее'
            onPress={onNotificationPress}
          />
        </View>
      )}
      <Text style={styles.time} testID='notification--date'>
        {datePipe(notification.dateTime, dateFormats.fullDateWithTime)}
      </Text>
    </Modal>
  );
};
